import React from 'react';
import { Markdown } from '@/components/Markdown';
import { defaultComponents } from '@/components/Markdown/components/ReactMarkdown';
import { Box, BoxProps } from '../../wag-react/next-components/box';
import { Typography } from '../../wag-react/components/Typography';
import { theme } from '../../wag-react/themes/base-theme';
import { LI } from '../../wag-react/core-components/li';
export type ProConBlockProps = {
  value: string;
} & BoxProps;
const components = {
  ...defaultComponents,
  h3: props => <Typography color={theme.colors.jewel} fontSize="22px" variant="h3" {...props} />,
  li: props => <LI color={theme.colors.jewel} {...props} />
};
export const ProConBlock = ({
  value,
  ...rest
}: ProConBlockProps) => <Box bg="#F1FBF9" borderRadius="12px" color={theme.colors.jewel} flex={1} px={['20px', '30px']} {...rest} data-sentry-element="Box" data-sentry-component="ProConBlock" data-sentry-source-file="index.tsx">
    <Markdown version="react-markdown" components={components} data-sentry-element="Markdown" data-sentry-source-file="index.tsx">
      {value}
    </Markdown>
  </Box>;